module.exports = __webpack_public_path__ + "img/fill-1-copy-11.4a777982.svg";